import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icn-urgent",
  "use": "icon-icn-urgent-usage",
  "viewBox": "0 0 10 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 13\" id=\"icon-icn-urgent\"><path d=\"M5.831 6.875l3.797 3.9c.492.505.496 1.328.011 1.839a1.216 1.216 0 01-1.767.01l-2.92-2.998-2.824 2.902c-.49.504-1.282.499-1.767-.012a1.337 1.337 0 01.01-1.838l3.703-3.803c.487-.5 1.27-.5 1.757 0zm0-6.5l3.797 3.9c.492.505.496 1.328.011 1.84a1.216 1.216 0 01-1.767.01l-2.92-2.998-2.824 2.901c-.49.505-1.282.5-1.767-.011a1.337 1.337 0 01.01-1.838L4.075.375c.487-.5 1.27-.5 1.757 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol